import { render } from "./PieChart2.vue?vue&type=template&id=571f84bf"
import script from "./PieChart2.vue?vue&type=script&lang=js"
export * from "./PieChart2.vue?vue&type=script&lang=js"

import "./PieChart2.vue?vue&type=style&index=0&id=571f84bf&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__